import { useState, useEffect, useTransition } from 'react'

export const useWindowSize = () => {
  const [, startTransition] = useTransition()
  const [windowHeight, setWindowHeight] = useState(0)
  const updateWindowHeight = () => {
    startTransition(() => {
      setWindowHeight(window.innerHeight)
    })
  }
  useEffect(() => {
    window.addEventListener('resize', updateWindowHeight)
    updateWindowHeight()
    return () => window.removeEventListener('resize', updateWindowHeight)
  }, [])

  return {
    height: windowHeight,
    width: undefined, // TODO: 必要になったら作る
  }
}
